import { Uploader } from "rsuite";
import { Attachment } from "@rsuite/icons";
import { useEffect } from "react";
import { CommonUploaderProps } from "../../../utils/typeDefs";

type InputTranslationFileUploaderProps = CommonUploaderProps & {
  isTranslationTitle: boolean;
  setIsTranslationFile: (value: boolean) => void;
  isTranslationFile:boolean;
};

const InputTranslationFileUploader = ({
  title,
  inputErrorMessage,
  showFileData,
  setShowFileData,
  setData,
  fileTitle,
  submitting,
  isTranslationTitle,
  setIsTranslationFile,
  isTranslationFile
}: InputTranslationFileUploaderProps) => {
  useEffect(() => {}, [isTranslationTitle]);

  return (
    <div className="row pb-2 form-input-field">
      <div className="col-12 col-md-3 my-auto">
        <p className="form-label">
          {title}:{" "}
          {
            isTranslationTitle &&
            !isTranslationFile &&
            inputErrorMessage("Required")}
        </p>
      </div>

      <div className="col-12 col-md-9 form-uploader-wrapper">
        <div className="d-flex flex-wrap form-label">
          <Uploader
            className="d-flex form-uploader"
            autoUpload={false}
            multiple={false}
            action=""
            onChange={(file) => {
              if (file) {
                setShowFileData(false);
                setData(file);
                if(!isTranslationFile && setIsTranslationFile){
                    setIsTranslationFile(true);
                }
              }
            }}
            onRemove={() => {
              if(isTranslationFile && setIsTranslationFile){
                setIsTranslationFile(false)
              }
            }}
            
            accept="application/pdf"
            renderFileInfo={(file, fileElement) => {
              return (
                <p
                  style={{ overflowWrap: "break-word" }}
                  className="form-label"
                >
                  {file.name}
                </p>
              );
            }}
          >
            <span>{showFileData ? "Replace File" : "Choose File"}</span>
          </Uploader>

          <div className={showFileData ? "my-auto p-1 form-label" : "d-none"}>
            <p>
              <Attachment /> {fileTitle}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InputTranslationFileUploader;
